// Role-aware notification filtering so the web portal matches the mobile app
// WITHOUT showing owners/dispatchers driver-only alerts (e.g. "trip assigned to you").
export function isDriverTargeted(n) {
  if (!n) return false;
  if (n.driver_id) return true;
  return typeof n.action_url === "string" && n.action_url.startsWith("/(driver)");
}

export function visibleNotifications(list, user) {
  if (!Array.isArray(list)) return [];
  const myDriverId = user?.driver_id || null;
  // Drivers see only their own alerts; everyone else sees org/ops-level alerts.
  if (myDriverId) return list.filter((n) => n.driver_id === myDriverId);
  return list.filter((n) => !isDriverTargeted(n));
}
